// src/common/DatePicker.tsx

import React from 'react';
import {
  KeyboardDatePicker as MuiKeyboardDatePicker,
  KeyboardDatePickerProps
} from '@material-ui/pickers';
import {
  getDateFormatFromStorage,
  getDateFormatOption
} from '../pages/Account';

/**
 * Custom KeyboardDatePicker to handle date format based on user settings from localStorage.
 * Usage:
 * <KeyboardDatePicker
 *   value={date}
 *   onChange={handleChange}
 *   // No need to provide format and placeholder in compoenent, it will be fetched automatically
 * />
 */
export const KeyboardDatePicker: React.FC<KeyboardDatePickerProps> = ({
  format,
  placeholder,
  ...props
}) => {
  // fetch format from localStorage
  const userFormat = getDateFormatFromStorage();
  const config = getDateFormatOption(userFormat);

  return (
    <MuiKeyboardDatePicker
      // handle format and placeholder
      format={format || config?.displayFormat || 'dd/MM/yyyy'}
      placeholder={placeholder || config?.placeholder || 'dd/mm/yyyy'}
      {...props}
    />
  );
};

// Export as default in case someone imports it as default
export default KeyboardDatePicker;
